module.exports = __webpack_public_path__ + "static/media/bus3.a17d2a74.jpg";